import React from 'react';
import { motion } from 'framer-motion';

/**
 * StudioManifesto — "Mais que um estúdio. Um lugar para ideias."
 * Usado exclusivamente na preview /studio.
 */
const StudioManifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="studio-manifesto-section"
      className="relative py-20 md:py-28 bg-[#050508] border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_left,rgba(245,158,11,0.10)_0%,rgba(0,0,0,0)_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_right,rgba(37,64,163,0.12)_0%,rgba(0,0,0,0)_55%)]" />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <span className="text-[10px] md:text-xs tracking-[0.5em] uppercase font-bold text-[#F59E0B] mb-6 inline-block">
            Manifesto
          </span>

          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#F5F5F0] leading-[1.05] mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Mais que um estúdio.
            <br />
            Um lugar para{' '}
            <span className="text-[#2540A3] italic font-black">ideias</span>.
          </h2>

          <p className="text-base md:text-lg text-[#D4D4D8] leading-relaxed font-light mb-4">
            Criatividade, técnica, pessoas e experiências reunidas em um só espaço.
            O Coutin Studio nasce para dar corpo ao que ainda existe só como
            <span className="text-[#F5F5F0] font-medium"> uma faísca de ideia.</span>
          </p>

          <p className="text-sm md:text-base text-[#8A8A8A] leading-relaxed font-light italic">
            Aqui, você grava, fotografa, produz e se conecta com o que realmente
            importa: o seu projeto.
          </p>

          <div className="mt-10 flex items-center justify-center gap-3">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-[#2540A3]/60" />
            <div className="w-1.5 h-1.5 rounded-full bg-[#F59E0B]" />
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-[#2540A3]/60" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StudioManifesto;
